import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { BundleData, KeyTechData, PeopleData } from 'client/bundles/types';

import Breadcrumbs from 'client/components/breadcrumbs';

import Card from 'client/components/card';
import SectionShiftTitle from 'client/components/section-shift-title';
import Seo from 'client/components/seo';
import SvgIcon from 'client/components/svg-icon';
import TitleAbout from 'client/components/title-about';
import WideStripe from 'client/components/wide-stripe';
import LangContext from 'client/utils/lang-context';

import './index.css';

const b = cn('about-team-and-tech');
const bPageTitle = cn('page-title');
const bPageText = cn('page-text');

interface Props {
    data: BundleData;
}

export default class AboutTeamAndTechPage extends Component<Props> {
    static contextType = LangContext;

    renderColums = (data: string[]) => (
        <ul className={b('colums')}>
            {data.map(item => (
                <li
                    key={item}
                    className={b('colum')}
                    dangerouslySetInnerHTML={{ __html: item }}
                    />
            ))}
        </ul>
    )

    renderCardsGrid = (
        data: PeopleData[] | KeyTechData[],
        renderCard: (item: PeopleData | KeyTechData) => JSX.Element
    ) => (
        <ul className={b('cards-list')}>
            {
                // @ts-ignore-next-line
                data.map(item => (
                    <li key={item.id} className={b('cards-item')}>
                        {renderCard(item)}
                    </li>
                ))
            }
        </ul>
    )

    renderPeopleCard = ({ icon, numbers, text }: PeopleData) => (
        <Card stretched>
            <div className={b('people-card')}>
                <SvgIcon mix={b('icon')} icon={icon} />
                <dl className={b('people-content')}>
                    <dt className={b('people-title')}>{numbers}</dt>
                    <dd className={b('people-text')} dangerouslySetInnerHTML={{ __html: text }} />
                </dl>
            </div>
        </Card>
    )

    renderTechCard = ({ icon, title }: KeyTechData) => (
        <Card stretched>
            <div className={b('tech-card')}>
                <SvgIcon mix={b('icon')} icon={icon} />
                <div className={b('tech-title')}>{title}</div>
            </div>
        </Card>
    )

    render() {
        const { title, text, image, team, people, tech, keyTech } = this.props.data.aboutTeamAndTech;
        const { dictionary } = this.context;

        return (
            <>
                <Seo title={title} />

                <div className={b()}>
                    <Breadcrumbs link="/about" text={dictionary.about} />

                    <h1 className={bPageTitle({ type: 'border' })}>{title}</h1>
                    <div className={bPageText()} dangerouslySetInnerHTML={{ __html: text }} />

                    <WideStripe isBanner background="gradient">
                        <picture>
                            <source srcSet={image['banner-team-desktop']} media="(min-width: 768px)" />
                            <img src={image['banner-team-phone']} className={b('image')} />
                        </picture>
                    </WideStripe>

                    <WideStripe>
                        <TitleAbout title={team.title} />

                        {this.renderColums(team.data)}
                    </WideStripe>

                    <div className={b('people')}>
                        <SectionShiftTitle
                            title={people.title}
                            childrenSecond={this.renderCardsGrid(people.data, this.renderPeopleCard)}
                            />
                    </div>

                    <WideStripe isBanner background="gradient">
                        <picture>
                            <source srcSet={image['banner-tech-desktop']} media="(min-width: 768px)" />
                            <img src={image['banner-tech-phone']} className={b('image')} />
                        </picture>
                    </WideStripe>

                    <WideStripe>
                        <TitleAbout title={tech.title} />

                        {this.renderColums(tech.data)}
                    </WideStripe>

                    <div className={b('key-tech')}>
                        <SectionShiftTitle
                            title={keyTech.title}
                            childrenSecond={this.renderCardsGrid(keyTech.data, this.renderTechCard)}
                            />
                    </div>
                </div>
            </>
        );
    }
}
